var setupAPM = function setupAPM(Vue, options) {
  var currentErrorHandler = Vue.config.errorHandler;

  Vue.config.errorHandler = function (error, vm, info) {
    var _window$RangersSiteSD, _window;

    window.RangersSiteSDK = window.RangersSiteSDK || window.apmPlus;
    (_window$RangersSiteSD = (_window = window).RangersSiteSDK) === null || _window$RangersSiteSD === void 0 ? void 0 : _window$RangersSiteSD.call(_window, 'captureException', error, {
      extraInfo: info
    });

    if (typeof currentErrorHandler === 'function') {
      currentErrorHandler.call(Vue, error, vm, info);
    }

    if (options === null || options === void 0 ? void 0 : options.logErrors) {
      console.error(error);
    }
  };
};

export { setupAPM };
//# sourceMappingURL=index.es.js.map
